import { set } from 'lodash/fp'

import ACTIONS from './action-types'

const initialPortal = {
  saleFlow: '',
}

const portal = (state = { ...initialPortal }, action) => {
  switch (action.type) {
    case ACTIONS.START_QQ_FLOW:
      return set('saleFlow', 'quick-quote')(state)
    case ACTIONS.START_FNA_FLOW:
      return set('saleFlow', 'fna')(state)
    default: {
      return state
    }
  }
}

export const reducer = portal
export default reducer
